import { render, staticRenderFns } from "./ImportSaldoStockist.vue?vue&type=template&id=3c107d52&"
import script from "./ImportSaldoStockist.vue?vue&type=script&lang=js&"
export * from "./ImportSaldoStockist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports